const Amplify = require( 'aws-amplify');
const { Logger } = require('aws-amplify');

Amplify.Logger.LOG_LEVEL = 'ERROR';

export default new Logger('BADesk-Frontend');